import { ArticleParagraph3, FormField, InputSlider } from '@cian/ui-kit';

import { type FC } from 'react';

import type { TFiltersDefaults } from '../../types/filtersDefaults';

import { getDownPaymentInPercents } from './utils/getDownPaymentInPercents';

import styles from './styles.css';

interface IMortgageOffersFiltersProps {
  filtersDefaults: TFiltersDefaults;
  price: number;
  downPayment: number;
  term: number;
  maxPrice: number;
  onPriceChanged: (value: number) => void;
  onDownPaymentChanged: (value: number) => void;
  onTermChanged: (value: number) => void;
  onPriceMouseDown: () => void;
  onDownPaymentMouseDown: () => void;
  onTermMouseDown: () => void;
}

export const MortgageOffersFilters: FC<IMortgageOffersFiltersProps> = ({
  filtersDefaults,
  price,
  downPayment,
  term,
  maxPrice,
  onPriceChanged,
  onDownPaymentChanged,
  onTermChanged,
  onPriceMouseDown,
  onDownPaymentMouseDown,
  onTermMouseDown,
}) => {
  const currencyAdornment = <span className={styles['adornment']}>₽</span>;
  const termAdornment = <span className={styles['adornment']}>лет</span>;
  const downPaymentInPercents = getDownPaymentInPercents(price, downPayment);

  return (
    <div className={styles['container']}>
      <div className={styles['field']}>
        <FormField label="Стоимость недвижимости" withoutMargin={true}>
          <InputSlider
            data-testid="PriceInput"
            max={maxPrice}
            min={0}
            rightAdornment={currencyAdornment}
            value={price}
            onChange={onPriceChanged}
            onMouseDown={onPriceMouseDown}
          />
        </FormField>
      </div>
      <div className={styles['field']}>
        <FormField label="Первоначальный взнос" withoutMargin={true}>
          <>
            <InputSlider
              data-testid="DownPaymentInput"
              max={price}
              min={Math.round(filtersDefaults.minDownPayment * price)}
              rightAdornment={currencyAdornment}
              step={Math.round(price / 100)}
              value={downPayment}
              onChange={onDownPaymentChanged}
              onMouseDown={onDownPaymentMouseDown}
            />
            <ArticleParagraph3 color="icon-secondary-default">{downPaymentInPercents}%</ArticleParagraph3>
          </>
        </FormField>
      </div>
      <div className={styles['field']}>
        <FormField label="Срок" withoutMargin={true}>
          <InputSlider
            data-testid="LoanTermInput"
            max={filtersDefaults.maxLoanTerm}
            min={filtersDefaults.minLoanTerm}
            rightAdornment={termAdornment}
            value={term}
            onChange={onTermChanged}
            onMouseDown={onTermMouseDown}
          />
        </FormField>
      </div>
    </div>
  );
};
